import { hasPermission } from "../../utils/hasPermission";
import { PERM, REPORT_EDIT_ALL_DIVISIONS } from "../../utils/permissions";

export const canEditAllReportProjects = (userInfo) =>
  REPORT_EDIT_ALL_DIVISIONS.includes(userInfo.div) &&
  hasPermission(userInfo.permissions, PERM.REPORT_EDIT_ALL);

// SRD와 CEO는 별도 보고 열이 없으므로 OF 공통 항목을 사용한다.
export const getReportDivision = (div) =>
  ["SRD", "CEO"].includes(div) ? "OF" : div;
